import React from 'react';
import './heading.css';
import './heading-container.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Heading = props => {
    const {
        children,
        id,
        headingType,
        size,
        colorScheme,
        align,
        withIndent,
        withSpacing,
    } = props;

    const headingClasses = classNames({
        heading: true,
        'heading--color-dark': colorScheme === 'dark',
        'heading--indent': withIndent === true,

        'heading--small': size === 'small',
        'heading--medium': size === 'medium',
        'heading--large': size === 'large',
    });

    const headingContainerClasses = classNames({
        'heading-container': true,
        'heading-container--align-left': align === 'left',
        'heading-container--align-right': align === 'right',
        'heading-container--spacing-false': withSpacing === false,
    });

    return (
        <div className={headingContainerClasses}>
            {(() => {
                switch (headingType) {
                    case 'h3':
                        return (
                            <h3 id={id} className={headingClasses}>
                                {children}
                            </h3>
                        );
                    case 'h4':
                        return (
                            <h4 id={id} className={headingClasses}>
                                {children}
                            </h4>
                        );
                    case 'h5':
                        return (
                            <h5 id={id} className={headingClasses}>
                                {children}
                            </h5>
                        );
                    case 'h6':
                        return (
                            <h6 id={id} className={headingClasses}>
                                {children}
                            </h6>
                        );
                    default:
                        return (
                            <h3 id={id} className={headingClasses}>
                                {children}
                            </h3>
                        );
                }
            })()}
        </div>
    );
};

Heading.defaultProps = {
    headingType: 'h3',
    size: 'large',
    colorScheme: 'light',
    align: 'center',
    withIndent: false,
    withSpacing: true,
};

Heading.propTypes = {
    headingType: PropTypes.oneOf(['h3', 'h4', 'h5', 'h6']),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    colorScheme: PropTypes.oneOf(['light', 'dark']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
    withIndent: PropTypes.bool,
    withSpacing: PropTypes.bool,
};

export { Heading };
